import DevPieChart, { IPieChartOptions, PieChartRef } from 'devextreme-react/pie-chart';
import React, { useMemo } from 'react';
import { useLocalization } from './hooks';

import '../../common/assets/devextreme/generic/dx.generic.module.css';
import '../../common/assets/devextreme/generic/reset.module.css';

export const PieChart = React.forwardRef<PieChartRef, IPieChartOptions>((props, ref) => {
	const dxPieChartRef = React.useRef<PieChartRef>();

	useLocalization();

	React.useImperativeHandle(ref, () => dxPieChartRef.current);

	const elementAttr = useMemo(
		() => ({
			'data-selenium-id': props.id
		}),
		[props.id]
	);

	return (
		<DevPieChart
			ref={dxPieChartRef}
			id={props.id}
			elementAttr={elementAttr}
			{...props}
		/>
	);
});
